"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.printChart = printChart;
var _ownerDocument = _interopRequireDefault(require("@mui/utils/ownerDocument"));
var _export = require("@mui/x-internals/export");
var _common = require("./common");
function printChart(element, {
  fileName
} = {}) {
  const printWindow = (0, _common.createExportIframe)(fileName);
  const doc = (0, _ownerDocument.default)(element);
  printWindow.onload = async () => {
    const printDoc = printWindow.contentDocument;
    const elementClone = element.cloneNode(true);
    const container = document.createElement('div');
    container.appendChild(elementClone);
    printDoc.body.innerHTML = container.innerHTML;
    const rootCandidate = element.getRootNode();
    const root = rootCandidate.constructor.name === 'ShadowRoot' ? rootCandidate : doc;
    await Promise.all((0, _export.loadStyleSheets)(printDoc, root));
    printWindow.contentWindow.print();
    const mediaQueryList = printWindow.contentWindow.matchMedia('print');
    mediaQueryList.addEventListener('change', mql => {
      const isAfterPrint = mql.matches === false;
      if (isAfterPrint) {
        doc.body.removeChild(printWindow);
      }
    });
  };
  doc.body.appendChild(printWindow);
}